var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayfb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5188C15 3.36842 11.64 0 7.5 0C3.36 0 0 3.36842 0 7.5188C0 11.1579 2.58 14.188 6 14.8872V9.77444H4.5V7.5188H6V5.6391C6 4.18797 7.1775 3.00752 8.625 3.00752H10.5V5.26316H9C8.5875 5.26316 8.25 5.6015 8.25 6.01504V7.5188H10.5V9.77444H8.25V15C12.0375 14.6241 15 11.4211 15 7.5188Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayfb);
export default __webpack_public_path__ + "static/media/grayfb.ba9f2bb5ce15cd990af1379f300582fd.svg";
export { ForwardRef as ReactComponent };